import { createReducer } from 'typesafe-actions';
import { PRODUCTS_COMPARE_SET_ACTIVE_GROUP_ID, ProductsCompareSetActiveGroupIdActions } from '../actions';

export const activeGroupId = createReducer<string, ProductsCompareSetActiveGroupIdActions>('').handleAction(
  PRODUCTS_COMPARE_SET_ACTIVE_GROUP_ID,
  (_, { payload }) => payload || '',
);
